module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_0.3489bd64.png";